import { Injectable } from '@angular/core';
import { ResourceService } from './resource.service';


@Injectable()
export class DateService {

    constructor(private resourceService: ResourceService) { }

    today: Date =  new Date();

    checkDateEquivalence(dateFormat: DateFormat, d1: Date, d2: Date) {
        let result = false;

        switch (dateFormat) {
            case DateFormat.Date:
                if (d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth()
                    && d1.getFullYear() === d2.getFullYear())
                    result = true;
                break;
            case DateFormat.Month:
                if (d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear())
                    result = true;
                break;
            case DateFormat.Year:
                if (d1.getFullYear() === d2.getFullYear())
                    result = true;
                break;
        }

        return result;
    }

    getLatestDate(d1: Date, d2: Date) {
        return d1.getTime() > d2.getTime() ? d1 : d2;
    }

    getFormatedDate(dateFormat: DateFormat, convertingDate?: Date): string {
        const date = convertingDate ? convertingDate : new Date();
        let formatedDate;
        switch (dateFormat) {
            case DateFormat.Date: // dd/mm//yyyy
                formatedDate = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
                break;
            case DateFormat.Month: // mm/yyyy
                formatedDate = (date.getMonth() + 1) + '/' + date.getFullYear();
                break;
            case DateFormat.Year: // yyyy
                formatedDate = date.getFullYear();
                break;
        }

        return formatedDate;
    }

    getSplitedDate(date: string): number[] {
        const split = date.split('/');
        let splitedDate: number[] = [];

        for (let i = 0; i < split.length; i++)
            splitedDate[i] = Number.parseInt(split[i]);

        return splitedDate;
    }

    generateWeeks(perioud: number[], startDate: Date) {
        const monthsName = [
            this.resourceService.Localize('reporting', 'Dashboard_Jan'),
            this.resourceService.Localize('reporting', 'Dashboard_Feb'),
            this.resourceService.Localize('reporting', 'Dashboard_Mar'),
            this.resourceService.Localize('reporting', 'Dashboard_Apr'),
            this.resourceService.Localize('reporting', 'Dashboard_May'),
            this.resourceService.Localize('reporting', 'Dashboard_Jun'),
            this.resourceService.Localize('reporting', 'Dashboard_Jul'),
            this.resourceService.Localize('reporting', 'Dashboard_Aug'),
            this.resourceService.Localize('reporting', 'Dashboard_Sep'),
            this.resourceService.Localize('reporting', 'Dashboard_Oct'),
            this.resourceService.Localize('reporting', 'Dashboard_Nov'),
            this.resourceService.Localize('reporting', 'Dashboard_Dec')];

        let firstOfMonth = new Date(), lastOfMonth = new Date(), weeks = [];
        let currentSplitedDate = this.getSplitedDate(this.getFormatedDate(DateFormat.Date));

        this.setDateInMonth(firstOfMonth, perioud[0] - 1, perioud[1]);
        // make first of month start with creation if this month equal month of creation date and years too
        firstOfMonth = this.getLatestDate(firstOfMonth, startDate);
        this.setEndOfMonth(lastOfMonth, perioud[0] - 1, perioud[1]);

        let start = firstOfMonth.getDate(), value = 0;
        let numDays = lastOfMonth.getDate();
        let end = this.endFirstWeek(firstOfMonth, 0) + start - 1; // make week start from sunday 

        if (currentSplitedDate[1] === (firstOfMonth.getMonth() + 1) &&
            currentSplitedDate[2] === firstOfMonth.getFullYear()) {

            while (start <= numDays && start <= currentSplitedDate[0]) {
                if (end > currentSplitedDate[0])
                    end = currentSplitedDate[0];

                weeks.push({
                    value: value,
                    start: start,
                    end: end,
                    month: monthsName[firstOfMonth.getMonth()]
                });

                start = end + 1;
                end = end + 7;
                value++;

                end = start === 1 && end === 8 ? 1 : end;
                if (end > numDays) {
                    end = numDays;
                }
            }
        }
        else {
            while (start <= numDays) {
                weeks.push({
                    value: value,
                    start: start,
                    end: end,
                    month: monthsName[firstOfMonth.getMonth()]
                });

                start = end + 1;
                end = end + 7;
                value++;

                end = start === 1 && end === 8 ? 1 : end;
                if (end > numDays) {
                    end = numDays;
                }
            }
        }
        return weeks;
    }

    endFirstWeek(firstDate: Date, firstDay: number) {
        if (!firstDay) {
            return 7 - firstDate.getDay();
        }
        if (firstDate.getDay() < firstDay) {
            return firstDay - firstDate.getDay();
        } else {
            return 7 - firstDate.getDay() + firstDay;
        }
    }

    setDateInMonth(startDate: Date, startMonth: number, currentYear?: number, date = 1) {
        startDate.setDate(date);
        startDate.setMonth(startMonth);

        if (currentYear)
            startDate.setFullYear(currentYear);
    }

    setEndOfMonth(endDate: Date, endMonth: number, currentYear: number) {
        var currentDate = new Date();
        endDate.setMonth(endMonth);
        endDate.setDate(new Date(currentYear, endMonth + 1, 0).getDate());

        if (currentYear === currentDate.getFullYear() && endMonth === currentDate.getMonth())
            endDate.setDate(currentDate.getDate());


        endDate.setFullYear(currentYear);
    }

    getPreviousDates( range = 1, date? :Date){
        if(!date){
            date = new Date();
        }
        date.setDate(date.getDate() - range);
        return date;
    }
    getMonthStart(month?, year?){
        let date = new Date();
        
        if(year){
            date.setFullYear(year);
        }

        date.setDate(1); // For Months that have 31 days should set date before month

        if(month){
            date.setMonth(month);
        }

        return date;
    }

    getMonthEnd(month?, year?){
        let date = new Date();
        
        

        if(month){
            date.setMonth(month + 1);
        }

        date.setDate(0);
        if(year){
            date.setFullYear(year);
        }
        return date;
    }
    getQuarterStart(quarter?, year?){
        let date = new Date();
        if(year){
            date.setFullYear(year);
        }
        if(!quarter){
            quarter = this.getQuarterNumber(date.getMonth());
        }
        switch(quarter){
            case 1:
                date.setMonth(0);
                break;
            case 2:
                date.setMonth(3);
                break;
            case 3:
                date.setMonth(6);
                break;
            case 4:
                date.setMonth(9);
                break;

        }

        date.setDate(1);

        return date;
    }
    getQuarterEnd(quarter?, year?){
        let date = new Date();
        
        if(!quarter){
            quarter = this.getQuarterNumber(date.getMonth());
        }
        switch(quarter){
            case 1:
                date.setMonth(3);
                break;
            case 2:
                date.setMonth(6);
                break;
            case 3:
                date.setMonth(9);
                break;
            case 4:
                date.setMonth(0);
                break;

        }
        
        date.setDate(0);
        
        if(year){
            date.setFullYear(year);
        }

        return date;
    }
    getQuarterNumber(month?){
        return Math.ceil( (month + 1) / 3 )
    }
    getYearStart(year?){
        let date = new Date();
        
        date.setDate(1);
        
        date.setMonth(0)

        if(year){
            date.setFullYear(year);
        }

        return date;
    }
    getYearEnd(year?){
        //let date = new Date();
        
        //date.setDate(0);
        
        //date.setMonth(11)
        let date =new Date(new Date().getFullYear(), 11, 31)
        if(year){
            date.setFullYear(year);
        }

        return date;
    }

    setDateStartOfDay(date: Date) {
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
    }

    setDateEndOfDay(date: Date) {
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
    }
}

export enum DateFormat {
    Date = 1,
    Month,
    Year
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/services/date.service.ts